import { type SvgIconComponent } from '@root/lib/types/components';

import { EnumHelper } from './helpers';

/**
 * Event kind enumeration
 * @enum {number}
 * @export
 */
export enum EVENT_KIND {
	ONE_TIME = 1,
	LONG_TERM = 2,
}

/**
 * Extra data interface for Event Kind
 * @export
 */
export interface EventKindExtraData {
	Icon?: SvgIconComponent;
}

/**
 * Event kind data type
 * @export
 */
export interface EventKindData extends EventKindExtraData {
	eventKindId: EVENT_KIND;
}

/**
 * List of supported event kinds. Currently base on `longTerm` field in `event.event` table.
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/event-settings.png
 * @type {EventKindData[]}
 */
/**
 * Event kind enumeration class
 * @export
 */
class EventKindEnum extends EnumHelper<EventKindExtraData, EVENT_KIND, 'eventKind', 'eventKindId'> {
	constructor() {
		super(
			'eventKind',
			{
				[EVENT_KIND.ONE_TIME]: {},
				[EVENT_KIND.LONG_TERM]: {},
			},
			'eventKindId',
			null,
		);
	}

	/**
	 * Returns event kind data based on the provided event config
	 * @param {C} config
	 * @returns {EventKindData}
	 */
	public fromConfig = <C extends { longTerm: boolean }>(config: C): EventKindData => {
		if (config.longTerm) return this.get(EVENT_KIND.LONG_TERM);
		return this.get(EVENT_KIND.ONE_TIME);
	};
}

/**
 * Event kind enumeration singleton instance export
 * @export
 */
export const eventKindEnum = new EventKindEnum();
